__turbopack_context__.v({
  "contentWrapper": "b3XkJa_contentWrapper",
  "descriptionWrapper": "b3XkJa_descriptionWrapper",
});
